<template>
	<div class="all_main">
		<myheader headTitle="更换手机号码"></myheader>
		<div class="backgroundC_white" style="padding: .15rem 0;">
			<van-field v-model="moblie" readonly label="手机号" />
		</div>
		<div class="margin_top_10 backgroundC_white" style="padding: .15rem 0;">
			<van-field v-model="newMoblie" type="number" maxlength="11" placeholder="请填写新的手机号码" clearable
				label="新手机号" />
		</div>
		<div class="backgroundC_white" style="padding: .15rem 0;">
			<div class="display_inline_block" style="width: 65%;">
				<van-field v-model="verifyCode" type="number" maxlength="6" placeholder="请输入计算结果" label="图形验证码"
					clearable />
			</div>
			<span @click="getPictureImg()" class="display_inline_block" title="看不清,换一个" style="width: 30%;">
				<img :src="verifyImg" style="height: 2rem;width: 5rem;" fill title="看不清,换一个" /></span>
		</div>
		<div class="backgroundC_white" style="padding: .15rem 0;">
			<div class="display_inline_block" style="width: 60%;">
				<van-field v-model="smcode" type="number" maxlength="6" placeholder="请输入验证码" label="验证码" clearable
					@keydown.enter="sumbitCheck()" />
			</div>
			<span @click="getCode()" class="display_inline_block text14 all_text_right all_line_height20"
				:class="{textcolormain:timer===60,textcolor999:timer!=60}"
				style="width: 35%;">{{timer===60?'获取验证码':(timer+'s后再次获取')}}</span>
		</div>
		<div class="all_tips_bottom_card">
			<button class="all_button24 width_100 text16 bmain_active" @click="sumbitCheck()">确定</button>
		</div>
	</div>
</template>


<script>
	import Vue from 'vue';
	import {
		Field
	} from 'vant';
	//Vue.use(Field);
	export default {
		components: {
			[Field.name]: Field,
		},
		data() {
			return {
				//验证码倒计时
				timer: 60,
				//手机号
				moblie: '',
				//新手机号
				newMoblie: '',
				//图片验证结果
				verifyCode: '',
				//验证Id
				verifyId: '',
				//验证图片
				verifyImg: '',
				//验证码
				smcode: ''
			}
		},
		methods: {
			//获取认证图片
			getPictureImg() {
				this.verifyCode = ''
				this.$store.dispatch(this.$LoadShow, true)
				this.$get('/register/api/getPictureImg').then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						this.verifyId = res.data.verifyId
						this.verifyImg = res.data.srcImg
					} else {
						this.verifyImg = ''
						this.$Toast("未获取到验证图片！");
					}
				}).catch((err) => {
					this.verifyImg = ''
					this.$store.dispatch(this.$LoadShow, false)
					console.log('getPictureImg', err)
				});
			},
			//获取验证码
			getCode() {
				if (this.timer != 60) {
					return
				}
				const reg = /^1[0-9]{10}$/;
				this.newMoblie = this.newMoblie.trim()
				if (
					this.newMoblie &&
					this.newMoblie.length == 11 &&
					reg.test(this.newMoblie)
				) {
					if (!this.verifyCode) {
						this.$Toast("请输入图形计算结果！");
						return
					}
					this.smsCode = '';
					this.$store.dispatch(this.$LoadShow, true)
					this.$post("/my/api/sendSmsCode", {
						mobile: this.newMoblie,
						type: 4, //type：1 登录、2 忘记密码、3 重置密码、4 更换手机号 5、个人认证
						verify: {
							code: this.verifyCode,
							id: this.verifyId
						}
					}).then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success) {
							this.$Toast("验证码已发送，请注意查收！");
							//this.smsCode = res.data;
							this.timer--;
							var timer1 = setInterval(() => {
								this.timer--;
								if (this.timer == 0) {
									this.timer = 60;
									clearTimeout(timer1);
								}
							}, 1000);
						} else {
							this.$Toast(res.message || "获取验证码失败！");
							this.getPictureImg()
						}
					}).catch(err=>{
						console.log('/my/api/sendSmsCode-=',err)
						this.$store.dispatch(this.$LoadShow, false)
						this.getPictureImg()
					})
				} else {
					this.$Toast("请输入正确的手机号码！");
				}
			},
			//更换手机号先核验手机号
			sumbitCheck() {
				const reg = /^1[0-9]{10}$/;
				this.newMoblie = this.newMoblie.trim()
				this.smcode = this.smcode.trim()
				if (
					this.newMoblie &&
					this.newMoblie.length == 11 &&
					reg.test(this.newMoblie)
				) {
					// if (this.newMoblie.toString() === this.$store.state.userInfo.mobile) {
					// 	this.$Toast("该手机号与当前账户手机号一致！");
					// 	return
					// }
					if (!this.smcode) {
						this.$Toast("请输入验证码！");
						return
					}
					this.$store.dispatch(this.$LoadShow, true)
					this.$post("/my/api/checkChangeMobile", {
						mobile: this.newMoblie,
						smsCode: this.smcode
					}).then((res) => {
						if (res.success) {
							this.changeMoblie()
						} else {
							this.$store.dispatch(this.$LoadShow, false)
							this.$Toast(res.message || "更换失败，请重试！");
							this.getPictureImg()
						}
					}).catch(err => {
						this.$Toast("更换失败，请重试！");
						this.$store.dispatch(this.$LoadShow, false)
						this.getPictureImg()
						console.log('changeMobileCheck', err)
					});
				} else {
					this.$Toast("请输入正确的手机号码！");
				}
			},
			//修改手机号
			changeMoblie() {
				this.$post("/my/api/changeMobile", {
					mobile: this.newMoblie,
					smsCode: this.smcode
				}).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success) {
						this.$Toast("更换成功，请重新登录！");
						window.localStorage.setItem("LoginInfo", '')
						window.localStorage.setItem("Identity_Token", '')
						this.$store.commit("changeLoginInfo", '')
						this.$store.commit("changeLoginToken", '')
						this.$store.dispatch("actionUserInfo", '');
						this.reLogin()
					} else {
						this.$Toast(res.message || "更换失败，请重试！");
						this.getPictureImg()
					}
				}).catch(err => {
					this.$Toast("更换失败，请重试！");
					this.$store.dispatch(this.$LoadShow, false)
					this.getPictureImg()
					console.log('changeMobile', err)
				});
			},
			//重新登录
			reLogin() {
				setTimeout(() => {
					this.$router.push('/login')
				}, 500)
			},
			//获取个人信息
			getUserInfo() {
				if (!this.$store.state.userInfo) {
					this.$store.dispatch(this.$LoadShow, true)
					this.$post("/my/api/getDetailForMobile")
						.then((res) => {
							this.$store.dispatch(this.$LoadShow, false)
							if (res.success && res.data) {
								this.$store.dispatch("actionUserInfo", res.data);
								this.moblie = this.$store.state.userInfo.mobile.replace(/^(\d{3})\d+(\d{4})$/,
									"$1****$2")
							}
						});
				} else {
					this.moblie = this.$store.state.userInfo.mobile.replace(/^(\d{3})\d+(\d{4})$/, "$1****$2")
				}
			},
		},
		mounted() {
			this.getUserInfo()
			this.getPictureImg()
		}
	}
</script>


<style scoped lang="scss">
	@import "../../styles/global.css";

	::v-deep .van-field__label {
		width: 3.2rem;
	}
</style>